import { render, staticRenderFns } from "./bannerForm.vue?vue&type=template&id=5b606c2e&scoped=true&"
import script from "./bannerForm.vue?vue&type=script&lang=js&"
export * from "./bannerForm.vue?vue&type=script&lang=js&"
import style0 from "./bannerForm.vue?vue&type=style&index=0&id=5b606c2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b606c2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b606c2e')) {
      api.createRecord('5b606c2e', component.options)
    } else {
      api.reload('5b606c2e', component.options)
    }
    module.hot.accept("./bannerForm.vue?vue&type=template&id=5b606c2e&scoped=true&", function () {
      api.rerender('5b606c2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/xcxPos/indexad/components/bannerForm.vue"
export default component.exports